// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navButton {
    color: white;
    background: #00383f;
    border-radius: 0;
    height: auto;
    padding-left: 1.5ch;
    padding-bottom: 0.45em;
    padding-top: 0.45em;
    border: black;
    text-align: left;
    transition: all 100ms;
    flex: 0 0 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    flex-direction: column;
    font-size: 100%;
}

.navButton:hover {
    color: white;
    background: rebeccapurple;
    transition: all 500ms;
}

.navButton.active {
    color: white !important;
    background: rebeccapurple !important;
}

.navButton.disabled {
    color: grey !important;
    background: #00383f !important;
    outline: none;
    border: none;
}

.customLink {
    color: white;
    background: #00383f;
    text-decoration: none;
    width: 100%;
    padding: 0.42em 1.5ch;
    outline: none;
    border: none;
}

.customLink:hover {
    color: white;
    background: rebeccapurple;
    transition: all 500ms;
    outline: none;
}

.activeLink {
    color: white;
    background: rebeccapurple;
    text-decoration: none;
    padding: 0.42em 1.5ch;
    width: 100%;
    outline: none;
}

.activeLink:hover {
    color: white;
}

.disabledLink {
    color: grey;
    background: #00383f;
    text-decoration: none;
    padding-left: 1.5ch;
    padding-top: 0.42em;
    padding-bottom: 0.42em;
    width: 100%;
    pointer-events: none;
}

.modeSelector {
    color: white;
    background-color: #00383f;
    text-decoration: none;
    border: none;
    padding-left: 1.5ch;
}

.modeSelector:focus {
    color: white;
    background-color: #00383f;
    box-shadow: none !important;
    outline: 0 !important;
}
`, "",{"version":3,"sources":["webpack://./src/stylesheets/Navigation.css"],"names":[],"mappings":"AAAA;IACI,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,YAAY;IACZ,mBAAmB;IACnB,sBAAsB;IACtB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,qBAAqB;IACrB,cAAc;IACd,aAAa;IACb,uBAAuB;IACvB,qBAAqB;IACrB,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,uBAAuB;IACvB,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;IACnB,qBAAqB;IACrB,WAAW;IACX,qBAAqB;IACrB,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;AACjB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,qBAAqB;IACrB,WAAW;IACX,aAAa;AACjB;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,qBAAqB;IACrB,mBAAmB;IACnB,mBAAmB;IACnB,sBAAsB;IACtB,WAAW;IACX,oBAAoB;AACxB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,qBAAqB;IACrB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,YAAY;IACZ,yBAAyB;IACzB,2BAA2B;IAC3B,qBAAqB;AACzB","sourcesContent":[".navButton {\n    color: white;\n    background: #00383f;\n    border-radius: 0;\n    height: auto;\n    padding-left: 1.5ch;\n    padding-bottom: 0.45em;\n    padding-top: 0.45em;\n    border: black;\n    text-align: left;\n    transition: all 100ms;\n    flex: 0 0 100%;\n    display: flex;\n    justify-content: center;\n    align-content: center;\n    flex-direction: column;\n    font-size: 100%;\n}\n\n.navButton:hover {\n    color: white;\n    background: rebeccapurple;\n    transition: all 500ms;\n}\n\n.navButton.active {\n    color: white !important;\n    background: rebeccapurple !important;\n}\n\n.navButton.disabled {\n    color: grey !important;\n    background: #00383f !important;\n    outline: none;\n    border: none;\n}\n\n.customLink {\n    color: white;\n    background: #00383f;\n    text-decoration: none;\n    width: 100%;\n    padding: 0.42em 1.5ch;\n    outline: none;\n    border: none;\n}\n\n.customLink:hover {\n    color: white;\n    background: rebeccapurple;\n    transition: all 500ms;\n    outline: none;\n}\n\n.activeLink {\n    color: white;\n    background: rebeccapurple;\n    text-decoration: none;\n    padding: 0.42em 1.5ch;\n    width: 100%;\n    outline: none;\n}\n\n.activeLink:hover {\n    color: white;\n}\n\n.disabledLink {\n    color: grey;\n    background: #00383f;\n    text-decoration: none;\n    padding-left: 1.5ch;\n    padding-top: 0.42em;\n    padding-bottom: 0.42em;\n    width: 100%;\n    pointer-events: none;\n}\n\n.modeSelector {\n    color: white;\n    background-color: #00383f;\n    text-decoration: none;\n    border: none;\n    padding-left: 1.5ch;\n}\n\n.modeSelector:focus {\n    color: white;\n    background-color: #00383f;\n    box-shadow: none !important;\n    outline: 0 !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
